import { useState } from "react";
import TitleInput from "../../../components/studio/TitleInput";
import { useNavigate } from "react-router-dom";
import DescriptionInput from "../../../components/studio/DescriptionInput";
import TagInput from "../../../components/studio/TagInput";
import AnimationInput from "../../../components/studio/AnimationInput";
import TheoryInput from "../../../components/studio/TheoryInput";
import VisualizationTheory from "../../../components/visualizationDetail/VisualizationTheory";
import { createVisualization } from "../../../services/visualizations.service";
import CreateVisualizationButton from "../../../components/studio/CreateVisualizationButton";

const CreateVisualization = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [animationId, setAnimationId] = useState(null);
  const [theory, setTheory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const submitHandler = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const publication = await createVisualization({
        title,
        description,
        tags,
        animationId,
        theory,
      });
      navigate(`/studio/visualizations/${publication.publicationId}`);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <TitleInput title={title} setTitle={setTitle} isLoading={isLoading} />
      <DescriptionInput
        description={description}
        setDescription={setDescription}
        isLoading={isLoading}
      />
      <TagInput tags={tags} setTags={setTags} isLoading={isLoading} />
      <AnimationInput
        animationId={animationId}
        setAnimationId={setAnimationId}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <TheoryInput
        theory={theory}
        setTheory={setTheory}
        isLoading={isLoading}
      />
      <VisualizationTheory theory={theory} />
      <CreateVisualizationButton
        submitHandler={submitHandler}
        loading={isLoading}
        error={error}
      />
    </>
  );
};

export default CreateVisualization;
